import React from 'react';
import { Box, Grid, makeStyles, Paper, Avatar } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
const useStyles = makeStyles((theme) => ({
  chatContainer: {
    padding: theme.spacing(1.25),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    // background: "#fff",
    height: "75%"
  },
  msgWrapper: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(4),
    width: '100%',
  },
  messageRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1.5),
    width: '100%'
  },
  messageBubble: {
    padding: theme.spacing(2, 3),
    borderRadius: 16,
    maxWidth: "100%"
  },
  leftMessage: {
    background: "#fff"
  },
  rightRow: {
    flexDirection: 'row-reverse',
    marginLeft: 'auto',
  },
  rightMessage: {
    background: "#fff"
  },
  avatar: {
    width: 32,
    height: 32,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    flexShrink: 0,
  },
  skeletonRight: {
    marginLeft: 'auto',   
  },
}));
const SkeletonLoader = ({ type = 'form', rows = 3, grid = [], isLabelled, listItems = 5, messages=[] }) => {
  const classes = useStyles();


  if (type === 'form') {
    return (
      <Box display="flex" flexDirection="column" gridGap={16}>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <Grid container spacing={2} key={rowIndex}>
            {Array.from({ length: grid[rowIndex] || 1 }).map((_, colIndex) => (
              <Grid item xs={12 / (grid[rowIndex] || 1)} key={colIndex}>
                {isLabelled && (
                  <Skeleton
                    animation="wave"
                    variant="text"
                    height={15}
                    width={150}
                    style={{ marginBottom: 8 }}
                  />
                )}
                <Skeleton
                  animation="wave"
                  variant="rect"
                  height={isLabelled ? 40 : 50}
                />
              </Grid>
            ))}
          </Grid>
        ))}
      </Box>
    );
  }

  if (type === 'tree') {
    return (
      <Box>
        {Array.from({ length: rows }).map((_, i) => (
          <Box
            key={i}
            pl={(i === 0 || i % 4 === 0) ? 0 : 5} mb={1}
            height={70}
          >
            <Skeleton variant='rect' animation='wave' height='100%' width={(i === 0 || i % 4 === 0) ? 400 : 360} />
          </Box>
        ))}
      </Box>
    );
  }

  if (type === 'code-editor') {
    return (
      <Box width='100%'>
        {Array.from({ length: 18 }).map((_, i) => (
          <Skeleton
            key={i}
            variant="text"
            animation="wave"
            height={18}
            width={`${90 - (i % 3) * 10}%`} // Varying line width
            style={{ marginBottom: 6 }}
          />
        ))}
      </Box>
    );
  }

  if (type === 'full') {
    return (
      <Skeleton variant="rect" width="100%" height="100vh" />
    );
  }

  if (type === 'list') {
    return (
      <Box display="flex" flexDirection="column" gap={1}>
        {Array.from({ length: listItems }).map((_, i) => (
          <Skeleton key={i} variant="text" width="100%" height={50} />
        ))}
      </Box>
    );
  }

  if (type === "chat") {
    return (
      <Box className={classes.chatContainer}>
        {messages.map((msg, index) => (
          <Box
            key={index}
            className={`${classes.msgWrapper} `}
          >
            <Box className={`${classes.messageRow} ${msg.type === "right" ? classes.rightRow : ""
              }`}>
              <Skeleton variant="circle" className={classes.avatar}>
                <Avatar />
              </Skeleton>
              <Paper
                elevation={1}
                className={`${classes.messageBubble} ${msg.type === "left"
                  ? classes.leftMessage
                  : classes.rightMessage
                  }`}
                style={{
                  width: msg.width
                }}
              >
                <Skeleton
                  variant="text"
                  width="100%"
                  height={20}
                  className={msg.type === "right" ? classes.skeletonRight : ""}
                />
                <Skeleton
                  variant="text"
                  width="80%"
                  height={20}
                  className={msg.type === "right" ? classes.skeletonRight : ""}
                />
              </Paper>
            </Box>
          </Box>
        ))}
      </Box>
    );
  }


  // Default fallback
  return (
    <Box>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} variant="text" />
      ))}
    </Box>
  );
};

export default SkeletonLoader;
